import React from "react";
import styled from "styled-components";
import media from "cssMix/index";

const PlayerRankItemWrapper = styled.div`
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 1px;
  background: ${(props) =>
    props.rank <= 3
      ? `linear-gradient(160deg, #5429af, #1b5b96)`
      : `rgba(249, 190, 0, 0.37)`};
  & .rank-item {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background: linear-gradient(110deg, rgb(19 17 51), rgb(32 18 75));
    border-radius: 8px;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    & .win {
      font-size: 16px;
      font-weight: 600;
      color: #f9be00;
    }
    &:hover {
      background: linear-gradient(110deg, rgb(37 18 93), rgb(18 57 94)),
        linear-gradient(160deg, rgb(84, 41, 175), rgb(27, 91, 150));
    }
    & > img {
      width: 54px;
      margin-right: 16px;
      ${media.tablet`
        width:44px;
      `}
    }
    & .rank-medal {
      color: #fff;
      position: relative;
      flex-shrink: 0;
      width: 36px;
      height: 36px;
      margin-right: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 15px;
      font-weight: bold;
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: ${(props) =>
          props.rank < 4
            ? `url("images/medal_top.png") no-repeat;`
            : `url("images/medal_default.png") no-repeat;`};
        background-size: 100% auto;
        background-position: center 2px;
      }
      ${media.tablet`
      width: 30px;
      height: 30px;
      font-size:12px;
      `}
    }
    & .rank-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 10px;
      & p {
        margin: 0;
      }
      & .game-name {
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      & .id-round {
        font-size: 14px;
        font-weight: 500;
        color: rgba(184, 194, 210, 0.5);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    & .rate {
      font-size: 15px;
      font-weight: 600;
      color: ${(props) => (props.rtpExp >= 0 ? "#50c577" : "#d02a43")};
      display: flex;
      align-items: center;
      margin-right: 16px;
      & .arrow {
        font-size: 12px;
        transform: scale(0.8);
        margin-left: 5px;
      }
    }
  }
`;

const PlayerRankItem = ({ rank, gameList, lang }) => {
  const gameDetail = gameList.filter(
    (v) => v.get("game_id") === rank.get("game_code")
  );

  return (
    <PlayerRankItemWrapper rank={rank.get("rank")}>
      <div className="rank-item">
        <div className="rank-medal">{rank.get("rank")}</div>
        <img alt="" src={gameDetail.getIn([0, "icon", lang])} />
        <div className="rank-info">
          <p className="game-name">{gameDetail.getIn([0, "name", lang])}</p>
          <p className="id-round">{`${rank.get("account")}/${rank.get(
            "round_id"
          )}`}</p>
        </div>
        <p className="win">{rank.get("win").toFixed(2)}</p>
      </div>
    </PlayerRankItemWrapper>
  );
};

export default PlayerRankItem;
